import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const UpdateListingDaynamic = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const products = location.state?.products || [];

  if (!products.length) {
    return <p className="text-center text-red-500">⚠ No products found!</p>;
  }

  // ✅ Open Delete Confirmation Modal
  const confirmDelete = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (!selectedProduct) return;

    setIsLoading(true);

    try {
      const productId = selectedProduct.Productid;
      const apiUrl = `https://backend.aktcorp.com/product/delete/${productId}`;

      const authToken = localStorage.getItem("authToken");

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API error:", errorText);
        throw new Error("❌ Failed to delete product. Please try again.");
      }

      navigate("/delete-listing"); // ✅ Navigate after delete
    } catch (error) {
      console.error("Error occurred while deleting product:", error);
      alert(error.message);
    } finally {
      setIsLoading(false);
      setIsModalOpen(false);
      setSelectedProduct(null);
    }
  };

  return (
    <div className="max-w-6xl mx-auto rounded-lg p-6 space-y-6">
      <h2 className="text-2xl font-bold text-center text-white">Matching Products</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((product) => (
          <div key={product.Productid} className="border p-4 rounded-lg shadow-md bg-gray-100">
            <img
              src={product.imageUrl?.S || product.imageUrl}
              alt={product.title?.[0]}
              className="w-full h-40 sm:h-48 md:h-60 object-contain rounded bg-gray-100"
            />
            <h3 className="text-lg font-semibold mt-2">{product.title?.[0]}</h3>
            <div
              className="text-base text-justify overflow-hidden line-clamp-5"
              dangerouslySetInnerHTML={{ __html: product.descriptions?.[0] }}
            ></div>
            <button
              onClick={() => confirmDelete(product)}
              className="mt-3 w-full bg-red-500 text-white p-2 rounded-md text-sm"
            >
              Delete Product
            </button>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-lg font-semibold">Are you sure?</h3>
            <p className="text-gray-600 mt-2">Do you really want to delete this product?</p>

            <div className="mt-4 flex justify-center gap-12">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded-md"
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-red-500 text-white px-4 py-2 rounded-md flex items-center justify-center"
                disabled={isLoading}
              >
                {isLoading ? <span>Deleting...</span> : "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateListingDaynamic;
